<template>
  <div>
    <section class="home">
      <div class="row">
        <div class="col-sm-9 col-sm-12 col-lg-9 home-right">
          <div class="d-flex home-right-titr d-flex">
            <h4>معلم یار</h4>
          </div>
          <div class="d-flex home-right-desc">
            <h5>سامانه یاری رسانی به معلمین برای ایجاد برابری آموزشی</h5>
          </div>
        </div>
        <div class="col-sm-3 col-sm-12 col-lg-3 home-left mt-3">
          <div class="home-left-box d-flex"  @click="goToSecondSection">
            <div class="d-flex home-left-box-icon">
              <i class="icon-hold1"></i>
            </div>
            <div class="d-flex home-left-box-span">
              <span></span>
            </div>
            <div class="d-flex home-left-box-p">
              <p>حمایت می کنم</p>
            </div>
          </div>
          <!-- <div class="home-left-box d-flex">
            <div class="d-flex home-left-box-icon">
              <i class="icon-warehouse"></i>
            </div>
            <div class="d-flex home-left-box-span">
              <span></span>
            </div>
            <div class="d-flex home-left-box-p">
              <p>تامین می کنم</p>
            </div>
          </div> -->

          <!-- <div class="home-left-box d-flex">
            <div class="d-flex home-left-box-icon">
              <i class="icon-teacher"></i>
            </div>
            <div class="d-flex home-left-box-span">
              <span></span>
            </div>
            <div class="d-flex home-left-box-p">
              <p>معلم هستم</p>
            </div>
          </div> -->
        </div>
      </div>
    </section>

    <section class="home1">
      <div class="row p-5">
        <div class="col-sm-5 col-sm-12 col-lg-5 home1-right">
          <div class="d-flex home1-right-img">
            <img src="@/assets/images/home/sale.png" alt />
          </div>
        </div>
        <div class="col-sm-7 col-sm-12 col-lg-7 home1-left">
          <div class="d-flex home1-left-icontitr mb-1">
            <div class="home1-left-icontext-icon">
              <i class="icon-hold1"></i>
            </div>
            <div class="home1-left-icontext-titr">
              <p>حمایت می کنم</p>
            </div>
          </div>

          <div class="home1-left-span mb-4"></div>
          <div class="home1-left-span-content">
            <p>
              توسعه کشور در گرو آموزش نسل های بعدی است. در اکثر مدارس ایران و به
              ویژه در مناطق کم برخوردارتر، معلمان به ابزارهای ضروری و مناسب برای
              ارتقاء کیفیت آموزشی دسترسی ندارند. حامیان این حرکت عده ای از
              نیکوکاران هستند که در قالب یک صندوق خصوصی، از نیازهای معلمان حمایت
              می کنند. سرمایه این صندوق از طریق همین حامیان و دوستان، آشنایان و
              همکاران ایشان تامین می گردد. حامیان از طریق پورتال شخصی خود می
              توانند همه سبدهای درخواستی را مشاهده کنند و به سبد یا سبدهای مورد
              نظر خود کمک مالی ارائه دهند.
            </p>
          </div>
          <div class="d-flex home1-left-button mt-5">
            <!-- <router-link :to="'/search'" tag="div" class="d-flex home1-left-button-b">
              <button >تامین کنندگان</button>
            </router-link> -->
            <div class="d-flex home1-left-button-b">
              <button v-b-modal.signup-real-person>ثبت نام حامیان</button>
            </div>
            <router-link to="/moalemyar" class="d-flex home1-left-button-b">
              <button>حمایت مالی </button>
            </router-link>
          </div>
        </div>
      </div>
      <!-- <div class="row p-5">
        <div class="col-sm-7 home1-left">
          <div class="d-flex home1-left-icontitr mb-1">
            <div class="home1-left-icontext-icon">
              <i class="icon-warehouse"></i>
            </div>
            <div class="home1-left-icontext-titr">
              <p>تامین کنندگان</p>
            </div>
          </div>

          <div class="home1-left-span mb-4"></div>
          <div class="home1-left-span-content">
            <p>یکی از اهداف معلم یار کمک به ایجاد و رشد شرکت های خصوصی در زمینه تولید محصولات آموزشی و کمک آموزشی است. این شرکت ها از طریق ارائه محصولات خود در بازار معلم یار هزینه های بازاریابی خود را به طور محسوسی کاهش داده به بازار بالقوه بزرگی دسترسی پیدا خواهند کرد. بدینترتیب، این شرکت ها قادر خواهند بود که تمرکز اصلی خود را بر طراحی و تولید محصولات نوآورانه اختصاص داده و نقش کلیدی خود را در توسعه کیفیت آموزش و ایجاد فرصت های آموزشی به بهترین وجه انجام دهند.</p>
          </div>
          <div class="d-flex home1-left-button mt-5">
              <div class="d-flex home1-left-button-b">
                  <button> مشاهده تامین کنندگان</button>
              </div>
              <div class="d-flex home1-left-button-b">
                  <button>ثبت نام تامین کنندگان</button>
              </div>
          </div>
        </div>
        <div class="col-sm-5 home1-right">
          <div class="d-flex home1-right-img">
            <img src="@/assets/images/home/tamin.png" alt />
          </div>
        </div>
      </div> -->

      <!-- <div class="row p-5">
        <div class="col-sm-5 home1-right">
          <div class="d-flex home1-right-img">
            <img src="@/assets/images/home/techer.png" alt />
          </div>
        </div>
        <div class="col-sm-7 home1-left">
          <div class="d-flex home1-left-icontitr mb-1">
            <div class="home1-left-icontext-icon">
              <i class="icon-teacher"></i>
            </div>
            <div class="home1-left-icontext-titr">
              <p>معلم هستم</p>
            </div>
          </div>

          <div class="home1-left-span mb-4"></div>
          <div class="home1-left-span-content">
            <p>بدون شک، وجود ابزار آموزشی و کمک آموزشی در بالا بردن کیفیت آموزشی تاثیر به سزائی دارد. با توجه به محدویت بودجه اکثر مدارس در فراهم آوردن این امکانات، معلم یار وظیفه خود می داند که با کمک حامیان فردی و سازمانی خود این ابزار و امکانات را برای معلمان فراهم نماید. معلم یار یک بازار محصولات آموزشی دارد که پیوسته در حال گسترش است. وقتی که به عنوان معلم در سایت معلم یار ثبت نام می کنید می توانید سبد محصولات مورد نیاز خود را تا سقف اعتبار تعیین شده انتخاب کنید و در معرض دید حامیان معلم یار قرار دهید. به محض اینکه هزینه سبد شما تامین شد، کادر معلم یار آنها را از تولید کنندگان خریداری کرده و برای شما ارسال خواهد کرد.</p>
          </div>
          <div class="d-flex home1-left-button mt-5">
              <div class="d-flex home1-left-button-b">
                  <button>مشاهده معلمین</button>
              </div>
              <div class="d-flex home1-left-button-b">
                  <button>ثبت نام معلمین </button>
              </div>
          </div>
        </div>
      </div> -->
    </section>
  </div>
</template>

<script>
export default {
  name: "Home",
  methods: {
    goToSecondSection() {
      let from = 0;
      let to = this.$el.getElementsByClassName("home1")[0].offsetTop;
      let goTo = setInterval(function () {
        window.scrollTo(0, from);

        if (from >= to) {
          clearInterval(goTo);
        } else {
          from += 7;
        }
      }, 1);
    },
    onClick() {
      this.busy = true;
      this.setTimeout(() => {
        this.$router.push({ path: `search/${this.value || ''}` });
        this.busy = false;
      });
    },
  },
};
</script>